import Btn from 'components/buttons/Btn'
import Reloader from 'components/buttons/Reloader'
import Icon from 'components/Icon'
import Screen from 'components/layout/Screen'
import DisableOrderingModal from 'pages/Status/DisableOrderingModal'
import OrderingStatus from 'pages/Status/OrderingStatus'
import { Card, CardDeck } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import API from 'state/API'
import { refreshRestaurants, useRestaurants } from 'state/Restaurants'
import 'pages/Status/styles.scss'
import { useModalState, useSimpleState } from 'utils'

export default function StatusPage() {
	const { t }              = useTranslation()
	const dispatch           = useDispatch()
	const restaurants        = useRestaurants()
	const selectedRestaurant = useSimpleState(restaurants[0])
	const modal              = useModalState()

	const corner = [
		<Reloader size="sm" resource={API.RESOURCES.RESTAURANTS} reloader={() => dispatch(refreshRestaurants)}/>,
	]

	function showDisableOrderingModal(restaurant) {
		selectedRestaurant.set(restaurant)
		modal.doOpen()
	}

	const CardContainer = (restaurants.length >= 3)? CardDeck : 'div' //no need of multiple columns for 2 cards
	return <Screen title={t('Ordering Status')} corner={corner}>
		<Screen.Content addPadding>
			<CardContainer>
				{restaurants.map(r => (
					<Card key={r.id}>
						<Card.Header>
							<Card.Title>{r.display_name}</Card.Title>
							<Card.Subtitle><Icon far i="clock"/> {r.localTime}</Card.Subtitle>
						</Card.Header>

						<Card.Body>
							<ul className="list-unstyled mb-0">
								{r.enabled_base_order_types.map(t => <OrderingStatus as="li" restaurant={r} type={t} key={t}/>)}
							</ul>
						</Card.Body>

						<Card.Footer>
							<Btn onClick={() => showDisableOrderingModal(r)} swap variant="secondary">
								{t('Update availability')}
							</Btn>
						</Card.Footer>
					</Card>
				))}

				<DisableOrderingModal restaurant={selectedRestaurant.val} {...modal}/>
			</CardContainer>
		</Screen.Content>
	</Screen>
}
